export const translations = {
  en: {
    title: "Refer Your Healthcare Provider",
    subtitle: "Help your provider discover Tibbbi's AI-powered triage system",
    incentiveMessage: "💰 Earn $50 credit when your provider signs up and starts using Tibbbi!",
    sections: {
      yourInfo: "Your Information",
      providerInfo: "Provider Information"
    },
    fields: {
      patientName: "Your Name",
      patientEmail: "Your Email",
      patientPhone: "Your Phone Number",
      providerName: "Provider's Name",
      providerClinic: "Clinic/Hospital Name",
      emailHint: "We'll send your referral code here",
      phoneHint: "Include country code (optional)",
      contactPrompt: "How would you like to receive your $50 reward?",
      contactEmail: "Email",
      contactPhone: "Phone"
    },
    validation: {
      required: "This field is required",
      invalidEmail: "Please enter a valid email address",
      invalidPhone: "Please enter a valid phone number",
      contactRequired: "Please provide either email or phone"
    },
    buttons: {
      cancel: "Cancel",
      submit: "Generate Referral Code",
      submitting: "Processing...",
      close: "Done"
    },
    success: {
      title: "Referral Created Successfully!",
      message: "Thank you for referring your provider!",
      description: "Your unique referral code has been generated. Share this code with your healthcare provider to earn your $50 credit.",
      codeLabel: "Your Referral Code:",
      copied: "Copied!",
      nextSteps: "What happens next:",
      step1: "Share this code with your healthcare provider",
      step2: "They'll use it when signing up for Tibbbi",
      step3: "You'll receive $50 credit once they complete registration"
    }
  },
  ar: {
    title: "أحل مقدم الرعاية الصحية الخاص بك",
    subtitle: "ساعد مقدم الرعاية الخاص بك على اكتشاف نظام الفرز المدعوم بالذكاء الاصطناعي من طبّي",
    incentiveMessage: "💰 احصل على رصيد 50$ عندما يشترك مقدم الرعاية الخاص بك ويبدأ في استخدام طبّي!",
    sections: {
      yourInfo: "معلوماتك",
      providerInfo: "معلومات مقدم الرعاية"
    },
    fields: {
      patientName: "اسمك",
      patientEmail: "بريدك الإلكتروني",
      patientPhone: "رقم هاتفك",
      providerName: "اسم مقدم الرعاية",
      providerClinic: "اسم العيادة/المستشفى",
      emailHint: "سنرسل رمز الإحالة الخاص بك هنا",
      phoneHint: "أدرج رمز البلد (اختياري)",
      contactPrompt: "كيف تريد استلام مكافأتك البالغة 50$؟",
      contactEmail: "البريد الإلكتروني",
      contactPhone: "الهاتف"
    },
    validation: {
      required: "هذا الحقل مطلوب",
      invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
      invalidPhone: "يرجى إدخال رقم هاتف صالح",
      contactRequired: "يرجى توفير البريد الإلكتروني أو الهاتف"
    },
    buttons: {
      cancel: "إلغاء",
      submit: "إنشاء رمز الإحالة",
      submitting: "جاري المعالجة...",
      close: "تم"
    },
    success: {
      title: "تم إنشاء الإحالة بنجاح!",
      message: "شكراً لك على إحالة مقدم الرعاية الخاص بك!",
      description: "تم إنشاء رمز الإحالة الفريد الخاص بك. شارك هذا الرمز مع مقدم الرعاية الصحية الخاص بك لكسب رصيد 50$.",
      codeLabel: "رمز الإحالة الخاص بك:",
      copied: "تم النسخ!",
      nextSteps: "ماذا يحدث بعد ذلك:",
      step1: "شارك هذا الرمز مع مقدم الرعاية الصحية الخاص بك",
      step2: "سيستخدمونه عند التسجيل في طبّي",
      step3: "ستتلقى رصيد 50$ بمجرد إكمالهم التسجيل"
    }
  },
  he: {
    title: "הפנה את ספק הבריאות שלך",
    subtitle: "עזור לספק שלך לגלות את מערכת המיון המבוססת על AI של טיבבי",
    incentiveMessage: "💰 הרווח קרדיט של $50 כשהספק שלך נרשם ומתחיל להשתמש בטיבבי!",
    sections: {
      yourInfo: "המידע שלך",
      providerInfo: "מידע הספק"
    },
    fields: {
      patientName: "השם שלך",
      patientEmail: "האימייל שלך",
      patientPhone: "מספר הטלפון שלך",
      providerName: "שם הספק",
      providerClinic: "שם המרפאה/בית החולים",
      emailHint: "נשלח את קוד ההפניה שלך לכאן",
      phoneHint: "כלול קוד מדינה (אופציונלי)",
      contactPrompt: "איך תרצה לקבל את הפרס של $50?",
      contactEmail: "אימייל",
      contactPhone: "טלפון"
    },
    validation: {
      required: "שדה זה נדרש",
      invalidEmail: "אנא הזן כתובת אימייל חוקית",
      invalidPhone: "אנא הזן מספר טלפון חוקי",
      contactRequired: "אנא ספק אימייל או טלפון"
    },
    buttons: {
      cancel: "ביטול",
      submit: "צור קוד הפניה",
      submitting: "מעבד...",
      close: "סיום"
    },
    success: {
      title: "ההפניה נוצרה בהצלחה!",
      message: "תודה על הפניית הספק שלך!",
      description: "קוד ההפניה הייחודי שלך נוצר. שתף קוד זה עם ספק הבריאות שלך כדי להרוויח את הקרדיט של $50.",
      codeLabel: "קוד ההפניה שלך:",
      copied: "הועתק!",
      nextSteps: "מה קורה אחר כך:",
      step1: "שתף קוד זה עם ספק הבריאות שלך",
      step2: "הם ישתמשו בו בעת ההרשמה לטיבבי",
      step3: "תקבל קרדיט של $50 ברגע שהם ישלימו את ההרשמה"
    }
  },
  fr: {
    title: "Référez votre prestataire de santé",
    subtitle: "Aidez votre prestataire à découvrir le système de triage alimenté par l'IA de Tibbbi",
    incentiveMessage: "💰 Gagnez 50$ de crédit lorsque votre prestataire s'inscrit et commence à utiliser Tibbbi!",
    sections: {
      yourInfo: "Vos informations",
      providerInfo: "Informations du prestataire"
    },
    fields: {
      patientName: "Votre nom",
      patientEmail: "Votre email",
      patientPhone: "Votre numéro de téléphone",
      providerName: "Nom du prestataire",
      providerClinic: "Nom de la clinique/hôpital",
      emailHint: "Nous enverrons votre code de référence ici",
      phoneHint: "Inclure le code pays (optionnel)",
      contactPrompt: "Comment souhaitez-vous recevoir votre récompense de 50$?",
      contactEmail: "Email",
      contactPhone: "Téléphone"
    },
    validation: {
      required: "Ce champ est requis",
      invalidEmail: "Veuillez entrer une adresse email valide",
      invalidPhone: "Veuillez entrer un numéro de téléphone valide",
      contactRequired: "Veuillez fournir un email ou un téléphone"
    },
    buttons: {
      cancel: "Annuler",
      submit: "Générer le code de référence",
      submitting: "Traitement...",
      close: "Terminé"
    },
    success: {
      title: "Référence créée avec succès!",
      message: "Merci d'avoir référé votre prestataire!",
      description: "Votre code de référence unique a été généré. Partagez ce code avec votre prestataire de santé pour gagner votre crédit de 50$.",
      codeLabel: "Votre code de référence:",
      copied: "Copié!",
      nextSteps: "Que se passe-t-il ensuite:",
      step1: "Partagez ce code avec votre prestataire de santé",
      step2: "Ils l'utiliseront lors de l'inscription à Tibbbi",
      step3: "Vous recevrez un crédit de 50$ une fois qu'ils auront terminé l'inscription"
    }
  },
  es: {
    title: "Refiere a tu proveedor de salud",
    subtitle: "Ayuda a tu proveedor a descubrir el sistema de triaje con IA de Tibbbi",
    incentiveMessage: "💰 Gana un crédito de $50 cuando tu proveedor se registre y empiece a usar Tibbbi!",
    sections: {
      yourInfo: "Tu información",
      providerInfo: "Información del proveedor"
    },
    fields: {
      patientName: "Tu nombre",
      patientEmail: "Tu correo electrónico",
      patientPhone: "Tu número de teléfono",
      providerName: "Nombre del proveedor",
      providerClinic: "Nombre de la clínica/hospital",
      emailHint: "Enviaremos tu código de referencia aquí",
      phoneHint: "Incluye el código de país (opcional)",
      contactPrompt: "¿Cómo te gustaría recibir tu recompensa de $50?",
      contactEmail: "Correo electrónico",
      contactPhone: "Teléfono"
    },
    validation: {
      required: "Este campo es obligatorio",
      invalidEmail: "Por favor, introduce una dirección de correo válida",
      invalidPhone: "Por favor, introduce un número de teléfono válido",
      contactRequired: "Por favor, proporciona correo electrónico o teléfono"
    },
    buttons: {
      cancel: "Cancelar",
      submit: "Generar código de referencia",
      submitting: "Procesando...",
      close: "Listo"
    },
    success: {
      title: "¡Referencia creada con éxito!",
      message: "¡Gracias por recomendar a tu proveedor!",
      description: "Tu código de referencia único ha sido generado. Comparte este código con tu proveedor de salud para ganar tu crédito de $50.",
      codeLabel: "Tu código de referencia:",
      copied: "¡Copiado!",
      nextSteps: "Qué ocurre a continuación:",
      step1: "Comparte este código con tu proveedor de salud",
      step2: "Lo usarán al registrarse en Tibbbi",
      step3: "Recibirás $50 de crédito una vez que completen el registro"
    }
  },
  de: {
    title: "Empfehlen Sie Ihren Gesundheitsanbieter",
    subtitle: "Helfen Sie Ihrem Anbieter, das KI-basierte Triage-System von Tibbbi zu entdecken",
    incentiveMessage: "💰 Verdienen Sie 50 $ Guthaben, wenn sich Ihr Anbieter anmeldet und Tibbbi nutzt!",
    sections: {
      yourInfo: "Ihre Informationen",
      providerInfo: "Anbieterinformationen"
    },
    fields: {
      patientName: "Ihr Name",
      patientEmail: "Ihre E-Mail",
      patientPhone: "Ihre Telefonnummer",
      providerName: "Name des Anbieters",
      providerClinic: "Name der Klinik/des Krankenhauses",
      emailHint: "Wir senden Ihren Empfehlungscode hierher",
      phoneHint: "Ländervorwahl angeben (optional)",
      contactPrompt: "Wie möchten Sie Ihre $50-Belohnung erhalten?",
      contactEmail: "E-Mail",
      contactPhone: "Telefon"
    },
    validation: {
      required: "Dieses Feld ist erforderlich",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      invalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein",
      contactRequired: "Bitte geben Sie entweder eine E-Mail oder eine Telefonnummer an"
    },
    buttons: {
      cancel: "Abbrechen",
      submit: "Empfehlungscode erstellen",
      submitting: "Verarbeitung...",
      close: "Fertig"
    },
    success: {
      title: "Empfehlung erfolgreich erstellt!",
      message: "Danke, dass Sie Ihren Anbieter empfohlen haben!",
      description: "Ihr individueller Empfehlungscode wurde erstellt. Teilen Sie diesen Code mit Ihrem Gesundheitsanbieter, um Ihr $50-Guthaben zu verdienen.",
      codeLabel: "Ihr Empfehlungscode:",
      copied: "Kopiert!",
      nextSteps: "Wie es weitergeht:",
      step1: "Teilen Sie diesen Code mit Ihrem Gesundheitsanbieter",
      step2: "Er wird ihn bei der Anmeldung bei Tibbbi verwenden",
      step3: "Sie erhalten $50 Guthaben, sobald die Registrierung abgeschlossen ist"
    }
  },
  hi: {
    title: "अपने स्वास्थ्य प्रदाता को रेफर करें",
    subtitle: "अपने प्रदाता को Tibbbi की एआई-संचालित ट्रायेज प्रणाली खोजने में मदद करें",
    incentiveMessage: "💰 जब आपका प्रदाता साइन अप करता है और Tibbbi का उपयोग शुरू करता है तो 50$ क्रेडिट कमाएँ!",
    sections: {
      yourInfo: "आपकी जानकारी",
      providerInfo: "प्रदाता की जानकारी"
    },
    fields: {
      patientName: "आपका नाम",
      patientEmail: "आपका ईमेल",
      patientPhone: "आपका फोन नंबर",
      providerName: "प्रदाता का नाम",
      providerClinic: "क्लिनिक/अस्पताल का नाम",
      emailHint: "हम आपका रेफरल कोड यहां भेजेंगे",
      phoneHint: "देश कोड शामिल करें (वैकल्पिक)",
      contactPrompt: "आप 50$ का इनाम कैसे प्राप्त करना चाहेंगे?",
      contactEmail: "ईमेल",
      contactPhone: "फोन"
    },
    validation: {
      required: "यह फ़ील्ड आवश्यक है",
      invalidEmail: "कृपया एक मान्य ईमेल पता दर्ज करें",
      invalidPhone: "कृपया एक मान्य फोन नंबर दर्ज करें",
      contactRequired: "कृपया ईमेल या फोन प्रदान करें"
    },
    buttons: {
      cancel: "रद्द करें",
      submit: "रेफरल कोड जनरेट करें",
      submitting: "प्रक्रिया जारी है...",
      close: "हो गया"
    },
    success: {
      title: "सफलतापूर्वक रेफरल बनाया गया!",
      message: "अपने प्रदाता को रेफर करने के लिए धन्यवाद!",
      description: "आपका अद्वितीय रेफरल कोड जनरेट कर लिया गया है। इस कोड को अपने स्वास्थ्य प्रदाता के साथ साझा करें ताकि आप 50$ क्रेडिट कमा सकें।",
      codeLabel: "आपका रेफरल कोड:",
      copied: "कॉपी किया गया!",
      nextSteps: "आगे क्या होगा:",
      step1: "इस कोड को अपने स्वास्थ्य प्रदाता के साथ साझा करें",
      step2: "वे Tibbbi में साइन अप करते समय इसका उपयोग करेंगे",
      step3: "पंजीकरण पूरा होने के बाद आपको 50$ क्रेडिट प्राप्त होगा"
    }
  },
  zh: {
    title: "推荐您的医疗提供者",
    subtitle: "帮助您的提供者发现 Tibbbi 的 AI 驱动分诊系统",
    incentiveMessage: "💰 当您的提供者注册并开始使用 Tibbbi 时，赚取 50 美元奖励！",
    sections: {
      yourInfo: "您的信息",
      providerInfo: "提供者信息"
    },
    fields: {
      patientName: "您的姓名",
      patientEmail: "您的电子邮件",
      patientPhone: "您的电话号码",
      providerName: "提供者姓名",
      providerClinic: "诊所/医院名称",
      emailHint: "我们会将您的推荐码发送到此",
      phoneHint: "包含国家代码（可选）",
      contactPrompt: "您希望如何接收 50 美元奖励？",
      contactEmail: "电子邮件",
      contactPhone: "电话"
    },
    validation: {
      required: "此字段为必填项",
      invalidEmail: "请输入有效的电子邮件地址",
      invalidPhone: "请输入有效的电话号码",
      contactRequired: "请提供电子邮件或电话"
    },
    buttons: {
      cancel: "取消",
      submit: "生成推荐码",
      submitting: "处理中...",
      close: "完成"
    },
    success: {
      title: "推荐创建成功！",
      message: "感谢您推荐您的提供者！",
      description: "您的专属推荐码已生成。将此代码分享给您的医疗提供者以赚取 50 美元奖励。",
      codeLabel: "您的推荐码：",
      copied: "已复制！",
      nextSteps: "接下来会发生什么：",
      step1: "将此代码分享给您的医疗提供者",
      step2: "他们将在注册 Tibbbi 时使用它",
      step3: "完成注册后，您将收到 50 美元奖励"
    }
  }
};